import { Component, Input, Output, OnChanges, EventEmitter, SimpleChanges } from '@angular/core';

import { UserFormService } from '../user-form/user-form.service';

@Component({
    selector: 'user-input',
    templateUrl: './user-input.component.html',
    styleUrls: ['./user-input.component.css']
})
export class UserInputComponent {
    @Input() value: any;
    @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() values: any;
    @Input() label: string;
    @Input() placeholder: string = "";
    @Input('values-label') valuesLabel: string = "";
    @Input('values-label-method') valuesLabelMethod: Function;
    @Input('value-label') valueLabel: string = "";
    @Input('control-class') controlClass: string = "";
    @Input('form-name') formName: string = "";
    @Input('min') minLength: IValidationMessage = { value: -9999999, message: "" };
    @Input('max') maxLength: IValidationMessage = { value: 9999999, message: "" };
    @Input('required') required: IValidationMessage = { value: false, message: "" };
    @Input('regex') regex: IValidationMessage = { value: "", message: "" };
    @Input('number') isNumber: IValidationMessage = { value: "", message: "" };
    @Input() suffix: string = "";
    @Input() prefix: string = "";
    @Input() protected: boolean = false;
    errors: string[];
    isTouched: boolean = false;
    isFocused: boolean = false;
    @Input("disabled") isDisabled: boolean = false;
    @Input("readonly") isReadOnly: boolean = false;
    @Input("delay") delay: number = 0;
    currentDelayHandle: number;
    @Input() multiline: boolean = false;
    @Output() onBlur = new EventEmitter();
    @Input("inputmode") inputMode: string;

    customErrors = [] as string[];

    constructor(private service?: UserFormService) {
    }

    get currentValue() {
        if (this.value === undefined || this.value === null || this.value.toString() == "NaN") {
            return "";
        }

        return this.value;
    }

    set currentValue(newValue) {
        this.isValid();

        if (newValue !== this.value) {
            if (this.isNumber.value) {
                if (newValue.toString().indexOf(",") !== -1) {
                    newValue = newValue.replace(",", ".");
                }
            }

            this.value = newValue && this.isNumber.value && !isNaN(Number(newValue)) ? Number(newValue) : newValue;

            if (this.delay) {
                if (this.currentDelayHandle)
                    clearTimeout(this.currentDelayHandle);

                this.currentDelayHandle = Number(setTimeout(() => {
                    this.emitChanges();
                }, this.delay));
            }
            else {
                this.emitChanges();
            }
        }
    }

    get currentDisplayValue() {
        if (!this.isFocused || !this.currentValue) {
            return this.currentValue;
        }
        else {
            return this.prefix + this.currentValue + this.suffix;
        }

    }

    emitChanges() {
        this.valueChange.emit(this.value);

        if (this.service) {
            this.service.inputChanged.emit(this.value);
        }
    }

    controlTouched() {
        this.isTouched = true;
    }

    controlFocused() {
        this.isFocused = true;
    }

    controlUnfocused() {
        this.isFocused = false;
        this.customErrors = [];
        this.hasError = false;
        this.errors = [];
        this.isValid();
        this.onBlur.emit();
        this.service.inputChanged.emit();
    }

    isMultible() {
        return this.values !== undefined;
    }

    ngOnChanges(change: SimpleChanges) {
        if (change.value !== this.currentValue && this.service) {
            this.service.inputChanged.emit(this.value);
        }
    }

    getName() {
        return this.formName || this.label;
    }

    hasError = false;

    isValid() {
        this.errors = [...this.customErrors];

        if (this.required.value === true && this.currentValue === "") {
            this.errors.push(this.replaceMessage(this.required.message, this.required.value));
        }

        //2 ways to check here, string length and number size:

        if (this.isNumber.value) {
            if (this.currentValue < this.minLength.value) {
                this.errors.push(this.replaceMessage(this.minLength.message, this.minLength.value));
            }

            if (this.currentValue > this.maxLength.value) {
                this.errors.push(this.replaceMessage(this.maxLength.message, this.maxLength.value));
            }
        }
        else {
            if (this.currentValue && this.currentValue.length < this.minLength.value) {
                this.errors.push(this.replaceMessage(this.minLength.message, this.minLength.value));
            }

            if (this.currentValue && this.currentValue.length > this.maxLength.value) {
                this.errors.push(this.replaceMessage(this.maxLength.message, this.maxLength.value));
            }
        }

        if (this.regex.value && this.currentValue && !this.regex.value.test(this.currentValue)) {
            this.errors.push(this.replaceMessage(this.regex.message, this.regex.value));
        }

        if (this.isNumber.value && this.currentValue && isNaN(this.currentValue)) {
            this.errors.push(this.replaceMessage(this.isNumber.message, this.isNumber.value));
        }

        return this.errors.length === 0;
    }

    replaceMessage(message: string, value: string) {
        return message.replace(/{label}/g, this.label).replace(/{value}/g, value);
    }

    getValueName(value: any) {
        if (this.valuesLabelMethod) {
            return this.getPrefix() + this.valuesLabelMethod(this.getValuesLabel(value)) + this.getSuffix();
        }
        else {
            return this.getPrefix() + this.getValuesLabel(value) + this.getSuffix();
        }
    }

    getValuesLabel(value: any) {
        var vallbl = this.valuesLabel;
        var seperator = " - ";

        if (vallbl && vallbl.indexOf(",") !== -1) {
            var split = vallbl.split(',');

            var content = "";
            for (let s of split) {
                content += value[s] + seperator;
            }

            return content.substring(0, content.lastIndexOf(seperator));
        }
        else {
            return this.valuesLabel ? value[this.valuesLabel] : value;
        }
    }

    getPrefix() {
        return this.prefix;
    }

    getSuffix() {
        return this.suffix;
    }
}

interface IValidationMessage {
    value: any;
    message: string;
}
